import React from "react";
import LockedFeatureItem from "./LockedFeatureItem";
import { NavLink } from "react-router-dom";
import { ClipboardList, Home, Package2, SquareCheckBig, Users } from "lucide-react";

const baseLinkClass =
  "flex min-w-0 flex-1 flex-col items-center justify-center gap-1 rounded-2xl px-2 py-2 text-[11px] font-medium transition-colors";

const MobileBottomNav = ({ appBase = "", featureAccess = {} }) => {
  const buildPath = (path) => {
    const cleaned = path.startsWith("/") ? path : `/${path}`;
    return appBase ? `${appBase}${cleaned}` : cleaned;
  };

  const items = [
    { to: buildPath("/dashboard"), label: "Home", icon: Home },
    { to: buildPath("/sample-orders"), label: "Samples", icon: ClipboardList },
    { to: buildPath("/accounts"), label: "Accounts", icon: Users },
    { to: buildPath("/inventory"), label: "Inventory", icon: Package2 },
    { to: buildPath("/tasks"), label: "Tasks", icon: SquareCheckBig },
  ];

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 px-3 pb-[calc(env(safe-area-inset-bottom)+0.7rem)] pt-2 md:hidden">
      <div className="mx-auto flex max-w-xl items-center gap-2 rounded-[1.75rem] border border-slate-200 bg-white/95 p-2 shadow-lg shadow-slate-900/10 backdrop-blur supports-[backdrop-filter]:bg-white/90">
        {items.map((item) => {
          const Icon = item.icon;
          const featureKey = item.to.endsWith('/orders') ? 'orders' : null;
          const access = featureKey ? featureAccess?.[featureKey] : null;
          if (access?.reason === 'hidden_entirely') {
            return null;
          }
          const locked = !!access && access.allowed === false;

          if (locked) {
            return (
              <LockedFeatureItem
                key={item.to}
                label={item.label}
                icon={<Icon className="h-4 w-4" />}
                message={access?.lockMessage || (access?.reason === 'paid_only' ? 'Paid plan required' : 'Hidden by developer')}
                className="flex min-w-0 flex-1 flex-col items-center justify-center gap-1 rounded-2xl px-2 py-2 text-[11px] font-medium text-slate-300"
                labelClassName="truncate"
                lockClassName="absolute -right-2 -top-1 h-3 w-3"
                bubbleClassName="w-48"
                stacked
              />
            );
          }

          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  baseLinkClass,
                  isActive
                    ? "bg-sky-600 text-white shadow-sm"
                    : "text-slate-500 hover:bg-slate-100 hover:text-slate-900",
                ].join(" ")
              }
            >
              <Icon className="h-4 w-4" />
              <span className="truncate">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default MobileBottomNav;
